export default __webpack_public_path__ + "static/media/novus.b0ad2715.png";